import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import PropTypes from 'prop-types';

ConfirmSubmitDialog.propTypes = {
  title: PropTypes.string,
  content: PropTypes.node,
  handleCloseSubmitDialog: PropTypes.func,
  onConfirmSubmit: PropTypes.func,
};
export default function ConfirmSubmitDialog({ title, content, handleCloseSubmitDialog, onConfirmSubmit }) {
  return (
    <Dialog open maxWidth="lg" sx={{ margin: 'auto', width: '35%' }} onClose={(event, reason) => {
      if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
      handleCloseSubmitDialog();
    }}>
      <DialogTitle sx={{ pb: 2, textAlign: 'center' }}>{title}</DialogTitle>
      <DialogContent sx={{ typography: 'body2' }}>{content}</DialogContent>
      <DialogActions>
        <Button variant="outlined" color={'error'} onClick={handleCloseSubmitDialog}>
          Go back
        </Button>
        <Button
          variant="contained"
          color={'primary'}
          onClick={() => {
            handleCloseSubmitDialog();
            onConfirmSubmit();
          }}
        >
          Submit invoice
        </Button>
      </DialogActions>
    </Dialog>
  );
}
